import { useEffect, type JSX } from 'react';
import { LightbulbRegular, QuestionCircleRegular } from '@fluentui/react-icons';
import type { Screen } from '../state/app.js';
import { SCREEN_HELP } from '../help/screenHelp.js';

/**
 * 화면별 도움말 — 현재 화면 위에 반투명 레이어로 띄움(일반 사용자 기준 설명).
 * 바깥 클릭·Esc·닫기로 닫힘.
 */
export function HelpLayer({ screen, title, onClose }: { screen: Screen; title: string; onClose: () => void }): JSX.Element {
  const help = SCREEN_HELP[screen];
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="dx-help-layer" onClick={onClose}>
      <div className="dx-help-panel" role="dialog" aria-modal="true" aria-labelledby="dx-help-title" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '18px 20px 14px', borderBottom: '1px solid #F1F3F5' }}>
          <QuestionCircleRegular aria-hidden style={{ fontSize: 26, color: '#2563EB', flexShrink: 0, marginTop: 2 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 11.5, fontWeight: 700, color: '#9CA3AF' }}>도움말</div>
            <div id="dx-help-title" style={{ fontSize: 16, fontWeight: 800, color: '#1F2937' }}>{title}</div>
          </div>
          <button className="dx-mf-x" onClick={onClose} aria-label="도움말 닫기">×</button>
        </div>
        <div style={{ padding: '14px 20px 18px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.65, color: '#374151' }}>{help.intro}</p>
          {help.sections.map((s) => (
            <section key={s.title}>
              <h4>{s.title}</h4>
              <ul>{s.items.map((it) => <li key={it}>{it}</li>)}</ul>
            </section>
          ))}
          {help.tip && <div className="dx-note" style={{ display: 'flex', gap: 8 }}><LightbulbRegular aria-hidden style={{ fontSize: 16, color: '#B45309', flexShrink: 0, marginTop: 2 }} /><span>{help.tip}</span></div>}
        </div>
        <div style={{ padding: '10px 20px', borderTop: '1px solid #F1F3F5', fontSize: 11.5, color: '#9CA3AF', display: 'flex' }}>
          <span>Esc 또는 바깥을 누르면 닫힙니다</span>
          <span style={{ marginLeft: 'auto' }}>내 정보 수정: 왼쪽 아래 내 이름</span>
        </div>
      </div>
    </div>
  );
}
